export default {"src":"/_next/static/media/motherhood.3aaccf25.svg","height":538,"width":668};